
export default class generalAdjustments {
    constructor() {
        if ($('.no-number-ol-js').length) {
            this._removeOrderedListStyle();
        }

        if ($('.deans-welcome-img-js').length) {
            this._checkDeansImageContent();
        }

        $('body *').each((index, $this) => {
            let text = $($this).text().trim();
            if (text === 'FAQ' || text === 'FAQs') {
                $($this).attr('aria-label', 'Frequently Asked Questions');
            }
        });

        $('a[target="_blank"]').attr('target', '_self');

        if ($('#social-dropdown-btn').length) {
            this._socialDropdown();
        }
    }

    _removeOrderedListStyle () {
        $('.no-number-ol-js').parents('ol, ul').addClass('remove-list-style');
    }

    _checkDeansImageContent () {
        if ($('.deans-welcome-img-js').children().length) {
            return;
        }

        $('.deans-welcome-content-wrap-js').addClass('no-side-image');
    }

    _socialDropdown () {
        // ******* Social Media button dropdown *********
        $('#social-dropdown-btn').on('click keydown', function (e) {
            var eventType = e.type;
            var keyPressed = e.which || e.keyCode;
            if (eventType === 'click' || (eventType === 'keydown' && (keyPressed === 32))) {
                let display = $('.get-connected');
                if (display.hasClass('hide-me')) {
                    $('.get-connected').removeClass('hide-me');
                    $('.get-connected').css({opacity: 0, display: 'flex'}).animate({
                        opacity: 1
                    }, 400);
                    $(this).attr('aria-expanded', 'true');
                } else {
                    $('.get-connected').addClass('hide-me');
                    $(this).attr('aria-expanded', 'false');
                    $('.get-connected').fadeOut("fast", "linear");

                }
            }
        });
    }

}